module.exports = __webpack_public_path__ + "static/fonts/weathericons-regular-webfont.2ca3df0.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/weather-icons/font/weathericons-regular-webfont.ttf
// module id = 689
// module chunks = 1